/// <reference path="../../types.d.ts"" />

import { connect } from 'react-redux';

import { mapDispatchToProps, mapStateToProps } from './dictionary-utils';
import { DictionaryList } from './dictionary-list';

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryList);
